import React from "react";
import { FILM } from "../mock";
import { Reveal } from "../hooks/useReveal";

const Film = () => {
  return (
    <section id="film" className="bg-[#151E1A] py-24 md:py-32 scroll-mt-20">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <Reveal className="flex items-center gap-4 mb-5">
          <span className="h-px w-10 bg-[#D2703F]" />
          <span className="eyebrow text-[#D2703F]">{FILM.eyebrow}</span>
        </Reveal>
        <Reveal>
          <h2 className="font-serif-display italic text-3xl md:text-5xl text-[#F4EFE6] leading-tight max-w-3xl">
            “{FILM.title}”
          </h2>
        </Reveal>

        {/* 16:9 landscape player */}
        <Reveal delay={100}>
          <div
            className="mt-10 relative w-full rounded-2xl overflow-hidden shadow-2xl shadow-black/40 bg-black"
            style={{ aspectRatio: "16 / 9" }}
          >
            <iframe
              src={FILM.embedUrl}
              title="SIQ Adventures film"
              className="absolute inset-0 w-full h-full"
              allow="autoplay; encrypted-media; fullscreen"
              allowFullScreen
            />
          </div>
        </Reveal>

        <Reveal delay={160}>
          <p className="mt-8 text-[#F4EFE6]/70 text-lg leading-relaxed max-w-2xl whitespace-pre-line">
            {FILM.subtitle}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Film;
